import { render } from "./JailRow.vue?vue&type=template&id=649ffea7"
import script from "./JailRow.vue?vue&type=script&lang=js"
export * from "./JailRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__